import { render, staticRenderFns } from "./delivery-price-removed-charges.vue?vue&type=template&id=cf8f2010"
import script from "./delivery-price-removed-charges.vue?vue&type=script&lang=js"
export * from "./delivery-price-removed-charges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports